const UserTypes = {
  FETCH_BROADCAST_MESSAGE: 'FETCH_BROADCAST_MESSAGE',
  SUBMIT_BUG_REPORT_OBJECT: 'SUBMIT_BUG_REPORT_OBJECT',
  USER_LOGIN_OBJECT: 'USER_LOGIN_OBJECT',
  USER_UPLOADS_OBJECT: 'USER_UPLOADS_OBJECT',
  REMOVE_USER_OBJECT: 'REMOVE_USER_OBJECT',
  USER_ERROR_MESSAGE: 'USER_ERROR_MESSAGE',
  ADMIN_FAILED_UPLOAD: 'ADMIN_FAILED_UPLOAD',
  ADMIN_UPLOADS: 'ADMIN_UPLOADS',
  UPLOAD_DATA: 'UPLOAD_DATA',
};

export default UserTypes;



// WEBPACK FOOTER //
// ./src/action-types/user.js